import { render, staticRenderFns } from "./collapsibleRowArrow.vue?vue&type=template&id=0f687a40&"
import script from "./collapsibleRowArrow.vue?vue&type=script&lang=js&"
export * from "./collapsibleRowArrow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports